import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Entity } from '../entity/entity';
import { GoogleService } from './google-service';
import { EntityHistory } from '../model/entity-history';

@Service()
export class EntityHistoryService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);
  private readonly baseUrl: string = environment.serviceUrl;

  getEntityHistory(entity: Entity): Observable<EntityHistory> {
    const url: string = this.baseUrl + 'entityHistory/' + entity.id.entityId + '/' + entity.id.entityRevision + '/' + entity.brandID;
    return this.http.get<EntityHistory>(url, { headers: this.getRequestHeaders() });
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }
}
